// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3a8aX","inputWrap":"styles_inputWrap__DetQ-","input":"styles_input__197Ph"};